import { useMutation } from '@tanstack/react-query';
import { fetchPublic, useApiRoot } from './fetchPublic';

/**
 * @typedef {Object} PublicConversationData
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} email
 * @property {string} phoneNumber
 * @property {string} clientToken
 * @property {string} message
 */

/**
 * Custom hook for creating a public conversation. Currently, this is
 * done with Intercomm on the backend. For "public", it means this is an
 * unauthenticated post and so requires a captcha.
 * POST /public/conversation — unauthenticated, so no auth headers.
 *
 * @returns {{ submit: Function, isLoading: boolean, error: unknown, isSuccess: boolean }}
 */
export default function usePublicConversation() {
  const apiRoot = useApiRoot();
  const url = `${apiRoot}/public/conversation`;

  const mutation = useMutation({
    mutationFn: (data) => fetchPublic(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include',
    }),
  });

  return {
    ...mutation,
    submit: mutation.mutate,
  };
}
